module.exports = __webpack_public_path__ + "img/selection.5136ee42.svg";